import { render, staticRenderFns } from "./EditScreen.vue?vue&type=template&id=223e3d2a&scoped=true"
import script from "./EditScreen.vue?vue&type=script&lang=ts"
export * from "./EditScreen.vue?vue&type=script&lang=ts"
import style0 from "./EditScreen.vue?vue&type=style&index=0&id=223e3d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223e3d2a",
  null
  
)

export default component.exports